import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, isSupported, Messaging } from 'firebase/messaging';
import { Firestore, getFirestore } from 'firebase/firestore';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// Dev creds
const firebaseConfig = {
	apiKey: import.meta.env.REACT_APP_FIREBASE_API_KEY,
	authDomain: import.meta.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
	projectId: import.meta.env.REACT_APP_FIREBASE_PROJECT_ID,
	storageBucket: import.meta.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
	messagingSenderId: import.meta.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
	appId: import.meta.env.REACT_APP_FIREBASE_APP_ID,
	measurementId: import.meta.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

let requestForToken: (
		notificationPermission: 'default' | 'denied' | 'granted',
		registerWorker?: boolean,
	) => Promise<string | void>,
	messaging: Messaging | undefined,
	fireStore: Firestore | undefined,
	tokenRetry = 0;

// window.isWebView is set by mobile app or else in IOS or firebase initialization the web breaks.
// eslint-disable-next-line
// @ts-ignore
if (typeof window !== 'undefined' && !window.isWebView) {
	try {
		// Initialize Firebase
		const firebaseApp = initializeApp(firebaseConfig);
		messaging = getMessaging(firebaseApp);
		fireStore = getFirestore(firebaseApp);

		const registerWebWorker = async () => {
			if ('serviceWorker' in navigator) {
				try {
					const registration = await navigator.serviceWorker.register(
						window.location.origin + '/firebase-messaging-sw.js',
					);
					await navigator.serviceWorker.ready;
					return registration;
				} catch (error) {
					console.error('Service Worker registration failed:', error);
				}
			}
		};

		requestForToken = async (notificationPermission, registerWorker) => {
			try {
				const isSupportedBrowser = await isSupported();

				if (isSupportedBrowser) {
					if (notificationPermission === 'granted' && messaging) {
						registerWorker && registerWebWorker();
						const token = await getToken(messaging, {
							vapidKey: import.meta.env.REACT_APP_FIREBASE_VAPID,
						}).catch((err) => {
							if (tokenRetry <= 3) {
								tokenRetry++;
								return requestForToken(notificationPermission, true);
							}
							console.error('An error occurred while retrieving token. ', err);
						});
						return token;
					} else {
						console.error('Notification permission denied');
					}
				}
			} catch (error) {
				console.warn('Firebase token request failed:', error);
				return undefined;
			}
		};

		registerWebWorker();
	} catch (error) {
		console.warn('Firebase initialization failed - browser may not support required APIs:', error);
		// Keep default no-op requestForToken
		messaging = undefined;
		fireStore = undefined;
	}
}
export { requestForToken, messaging, fireStore };